/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { actions as orderActions } from './sagaSlice';
import { actions as unitTypeActions } from '@/_unit-types/sagaSlice';
import {
    Table, Header, Modal, Button
} from 'semantic-ui-react';
import Dimmer from '+/Dimmer';
import Form from './Form';
import Get from 'lodash/get';
import PropertyHeader from './PropertyHeader';

import Dayjs from 'dayjs';

const formatBool = val => {
    if (val === null) return '';

    return val ? 'Yes' : 'No';
};

const formatDate = date => {

    if (date) {
        return Dayjs(date).format('MM/DD/YYYY').toString();
    }

    return '';

};

const getUnitType = (orders, unitTypeMappings) => {

    const lookup_code = Get(orders, '[0].lookup_code');
    const unit_space_name = Get(orders, '[0].unit_space_name');

    if (lookup_code && unit_space_name) {

        return Get(unitTypeMappings, `${lookup_code}.${unit_space_name}`);
    }

    return 'N/A';
};

const ListOrders = props => {
    const {
        match,
        getAmenities,
        orders,
        isFetching,
        notInEntrata,
        customOrders,
        entrataDown,
        deleteAmenityNote,
        role,
        fetchUnitTypeMappings,
        unitTypeMappings,
        unitTypeMappingsLoading
        // user_id
    } = props;
    const { property_id } = match.params;

    const [modalOpen, setModalOpen] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    // const { data } = useFetchPermissions(user_id);


    const isAdmin = role === 'admin';
    const canEdit = /admin|manager/.test(role);

    const onSubmit = values => {

        const payload = {
            id: values.id,
            lookup_code: values.lookup_code || initialValues.lookup_code,
            unit_space_name: values.unit_space_name || initialValues.unit_space_name,
            amenity_name: values.amenity_name || initialValues.amenity_name,
            manager_notes: values.manager_notes,
            owner_notes: values.owner_notes,
            ordered: values.ordered,
            date_paid: values.date_paid,
            check_number: values.check_number,
            paid: values.paid,
            property_id,
            original: {
                amenity_name: initialValues.amenity_name,
                lookup_code: initialValues.lookup_code,
                unit_space_name: initialValues.unit_space_name,
                type_id: initialValues.type_id,
                created_at: initialValues.created_at
            }
        };

        props.addNotes(payload);
        setModalOpen(false);
    };

    const handleEdit = order => {
        setInitialValues(order);
        setModalOpen(true);
    };

    useEffect(() => {
        fetchUnitTypeMappings();
    }, [fetchUnitTypeMappings]);

    useEffect(() => {
        getAmenities(property_id);
    }, [getAmenities, property_id]);


    if (isFetching || unitTypeMappingsLoading) return <Dimmer />;

    return (
        <div>
            <PropertyHeader property_id={property_id} />


            {entrataDown && Object.entries(entrataDown).length !== 0 && <Header as='h5' content='Entrata is Down' color='red'/>}
            {
                entrataDown && Object.entries(entrataDown).length !== 0 && Object.entries(entrataDown).map(([unit_name, orders], i) => (
                    <Table celled padded key={`table-${i}`}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell content={`${unit_name} (${getUnitType(orders, unitTypeMappings)})`} width={1}/>
                                <Table.HeaderCell content='Amenity' />
                                <Table.HeaderCell content='Manager Notes' />
                                {isAdmin && <Table.HeaderCell content='Owner Notes' />}
                                <Table.HeaderCell content='Ordered' />
                                <Table.HeaderCell content='Amount' />
                                {isAdmin && (
                                    <>
                                        <Table.HeaderCell content='Paid' />
                                        <Table.HeaderCell content='Date Paid' />
                                        <Table.HeaderCell content='Date Ordered' />
                                        <Table.HeaderCell content='Check #' />
                                    </>
                                )}
                                <Table.HeaderCell textAlign='center' content='Edit' width={1}/>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {(orders || []).map((order, _i) => (
                                <Table.Row key={`orders-${_i}`}>
                                    <Table.Cell />
                                    <Table.Cell content={order.amenity_name} />
                                    <Table.Cell>{order.manager_notes}</Table.Cell>
                                    {isAdmin && <Table.Cell>{order.owner_notes}</Table.Cell>}
                                    <Table.Cell content={formatDate(order.ordered)} />
                                    <Table.Cell content={order.total_current} />
                                    {isAdmin && (
                                        <>
                                            <Table.Cell content={formatBool(order.paid)} />
                                            <Table.Cell content={formatDate(order.date_paid)} />
                                            <Table.Cell content={order.check_number} />
                                        </>
                                    )}
                                    <Table.Cell textAlign='center'>
                                        <Button icon='edit' onClick={() => handleEdit(order)} />
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                ))
            }

            {customOrders && customOrders.length !== 0 && (
                <div>
                    <Header as='h5' content='Custom Orders' />
                    <Table color='black'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell content='Unit name' width={1} />
                                <Table.HeaderCell content='Amenity' />
                                <Table.HeaderCell content='Manager Notes' />
                                {isAdmin && (
                                    <>
                                        <Table.HeaderCell content='Owner Notes' />
                                        <Table.HeaderCell content='Ordered' />
                                        <Table.HeaderCell content='Paid' />
                                        <Table.HeaderCell content='Date Paid' />
                                        <Table.HeaderCell content='Check #' />
                                    </>
                                )}
                                <Table.HeaderCell content='Delete' />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {(customOrders).map((notIn, i) => (
                                <Table.Row key={`missingOrders-${i}`}>
                                    <Table.Cell content={`${notIn.unit_space_name} (${Get(unitTypeMappings, `${notIn.lookup_code}.${notIn.unit_space_name}`, 'N/A')})`} />
                                    <Table.Cell content={notIn.amenity_name} />
                                    <Table.Cell content={notIn.manager_notes} />
                                    {isAdmin && (
                                        <>
                                            <Table.Cell content={notIn.owner_notes} />
                                            <Table.Cell content={formatDate(notIn.ordered)} />
                                            <Table.Cell content={formatBool(notIn.paid)} />
                                            <Table.Cell content={formatDate(notIn.date_paid)} />
                                            <Table.Cell content={notIn.check_number} />
                                            <Table.Cell textAlign='center' width={1}>
                                                <Button onClick={() => deleteAmenityNote(notIn)} icon='delete' />
                                            </Table.Cell>
                                        </>
                                    )}
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    <hr></hr>
                </div>
            )}
            {notInEntrata && notInEntrata.length !== 0 && (
                <div>
                    <Header as='h5' content='Not In Entrata' />
                    <Table color='black'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell content='Unit name' width={1} />
                                <Table.HeaderCell content='Amenity' />
                                <Table.HeaderCell content='Manager Notes' />
                                {isAdmin && (
                                    <>
                                        <Table.HeaderCell content='Owner Notes' />
                                        <Table.HeaderCell content='Ordered' />
                                        <Table.HeaderCell content='Paid' />
                                        <Table.HeaderCell content='Date Paid' />
                                        <Table.HeaderCell content='Check #' />
                                    </>
                                )}
                                <Table.HeaderCell content='Delete' />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {(notInEntrata).map((notIn, i) => (
                                <Table.Row key={`missingOrders-${i}`}>
                                    <Table.Cell content={`${notIn.unit_space_name} (${Get(unitTypeMappings, `${notIn.lookup_code}.${notIn.unit_space_name}`, 'N/A')})`} />
                                    <Table.Cell content={notIn.amenity_name} />
                                    <Table.Cell content={notIn.manager_notes} />
                                    {isAdmin && (
                                        <>
                                            <Table.Cell content={notIn.owner_notes} />
                                            <Table.Cell content={formatDate(notIn.ordered)} />
                                            <Table.Cell content={formatBool(notIn.paid)} />
                                            <Table.Cell content={formatDate(notIn.date_paid)} />
                                            <Table.Cell content={notIn.check_number} />
                                            <Table.Cell textAlign='center' width={1}>
                                                <Button onClick={() => deleteAmenityNote(notIn)} icon='delete' />
                                            </Table.Cell>
                                        </>
                                    )}
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                    <hr></hr>
                </div>
            )}

            {Object.entries(orders || {}).map(([unit_name, orders], i) => (
                <Table celled padded key={`table-${i}`}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell content={`${unit_name} (${getUnitType(orders, unitTypeMappings)})`} width={1}/>
                            <Table.HeaderCell content='Amenity' />
                            <Table.HeaderCell content='Manager Notes' />
                            {isAdmin && <Table.HeaderCell content='Owner Notes' />}
                            <Table.HeaderCell content='Ordered' />
                            <Table.HeaderCell content='Amount' />
                            {isAdmin && (
                                <>
                                    <Table.HeaderCell content='Paid' />
                                    <Table.HeaderCell content='Date Paid' />
                                    <Table.HeaderCell content='Check #' />
                                </>
                            )}
                            <Table.HeaderCell textAlign='center' content='Edit' width={1}/>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {(orders || []).map((order, _i) => (
                            <Table.Row key={`orders-${_i}`}>
                                <Table.Cell />
                                <Table.Cell content={order.amenity_name} />
                                <Table.Cell>{order.manager_notes}</Table.Cell>
                                {isAdmin && <Table.Cell>{order.owner_notes}</Table.Cell>}
                                <Table.Cell content={formatDate(order.ordered)} />
                                <Table.Cell content={order.total_current} />
                                {isAdmin && (
                                    <>
                                        <Table.Cell content={formatBool(order.paid)} />
                                        <Table.Cell content={formatDate(order.date_paid)} />
                                        <Table.Cell content={order.check_number} />
                                    </>
                                )}
                                {canEdit && (
                                    <Table.Cell textAlign='center'>
                                        <Button icon='edit' onClick={() => handleEdit(order)} />
                                    </Table.Cell>
                                )}
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            ))}

            <Modal open={modalOpen} size='tiny'>
                <Modal.Content>
                    <Form setModalOpen={setModalOpen} initialValues={initialValues} onSubmit={onSubmit} role={role}/>
                </Modal.Content>
            </Modal>
        </div>
    );
};

const mapStateToProps = state => ({
    orders: state.orders.data,
    isFetching: state.orders.isFetching,
    notInEntrata: state.orders.notInEntrata?.filter(x => x.custom === false),
    customOrders: state.orders.notInEntrata?.filter(x => x.custom === true),
    entrataDown: state.orders.entrataDown,
    role: state.auth.role,
    user_id: state.auth.id,
    unitTypeMappings: state['unit-types'].mappings,
    unitTypeMappingsLoading: state['unit-types'].isFetching
});

const actions = {
    ...orderActions,
    fetchUnitTypeMappings: unitTypeActions.fetchUnitTypeMappings
};

export default connect(mapStateToProps, actions)(ListOrders);
